import styled from "styled-components";
import {Descriptions, Avatar, Button, Tag, Table, Typography, List, Select} from "antd";
import {MinusCircleFilled, FileImageFilled} from "@ant-design/icons";

const {Text} = Typography;

export const DescriptionContainer = styled(Descriptions)`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const OrderNumber = styled(Text)`
    font-weight: bold;
`;

export const MergedOrderStats = styled(Text)`
    font-weight: bold;
    float: left;
`;

export const OrderTotalTime = styled(Text)`
    font-weight: bold;
    float: right;
`;

export const TransferInfoContainer = styled.div`
    padding: 0 35px 35px;
    margin-top: 5px;
    margin-bottom: 20px;
    border: 1px solid #f0f0f0;
`;

export const TransferLogList = styled(List)`
    .ant-list-item {
        padding: 6px 0;
    }
    .ant-list-item-meta-title {
        margin-bottom: 0px;
        font-weight: 300;
    }
    .ant-list-item-meta {
        margin-bottom: 0px;
    }
`;

export const TransferDescription = styled.p`
    font-size: 12px;
    color: black;
`;

export const StepContainer = styled.div`
    position: relative;
    padding: 0 35px 35px;
    border: 1px solid #f0f0f0;
    margin-bottom: 30px;
    margin-top: 5px;
    .ant-steps-item-content {
        width: auto;
    }
`;

export const MapContainer = styled.div`
    width: 100%;
    max-width: 100vw;
    height: 350px;
    overflow: auto;
    border: 1px solid white;
    border-radius: 4px;
    z-index: 1;
    position: relative;
    /*            ^^ */
    ${({mode}) =>
        mode == "fixed" &&
        `position:fixed;
        left: 105px;
        right:25px;
        bottom:40px;
        top:95px;
        width:inherit;
        height:inherit;`}

    /* Google Maps sağ alt köşe yazılarını gizle */
    .gmnoprint, .gm-style-cc, .gmnoprint a, .gmnoprint span {
        display: none !important;
    }
`;
export const MapTools = styled(Button)`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 5;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    svg {
        width: 1.5em;
        height: 1.5em;
        margin: 5px;
    }
`;

export const Marker = styled(Avatar)`
    position: absolute;
    background-color: ${props => props.color};
    transform: translate(-50%, -50%);
    border: 1px solid #021529;
    box-sizing: content-box;
    color: #021529;
    z-index: ${props => (props.$hover ? 2 : 1)};
    font-size: 14px !important;
    border-radius: ${props => props.$hover && "4px"};
    width: ${props => props.$hover && "auto"} !important;
    &:after {
        content: ${props => props.$hover && `"${props.text}"`};
        margin-left: 5px;
    }
    padding: ${props => props.$hover && "5px"} !important;
    transition: border-radius 0.1s;

    ${props =>
        props.$hover &&
        `
        > * {
            display: none;
        }
    `}
`;

export const TableTitle = styled.h3`
    margin: 15px 0%;
    font-size: 1.17em !important;
`;

export const TableOverflow = styled.div`
    width: 100%;
    max-width: 100vw;
    overflow-x: auto;
    overflow-y: visible;
`;
export const LeftButton = styled(Button)`
    padding-right: 50px;
    padding-left: 50px;
`;
export const MiddleButton = styled(Button)`
    margin-right: 20px;
    margin-left: 20px;
`;
export const RightButton = styled(Button)`
    float: right;
`;

export const AnnulmentButton = styled(Button)`
    display: ${props => (props.visible === "true" ? "none" : "block")};
    margin: auto;
    width: 90px;
`;
export const PassButton = styled(Button)`
    margin-top: 3px;
    margin-bottom: 10px;
    width: 90px;
`;

export const DetailTag = styled(Tag)`
    margin-bottom: 0.5rem;
    margin-left: 5px;
`;

export const SpinnerContainer = styled.div`
    position: absolute;
    width: calc(100% - 70px);
    height: calc(100% - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffffbf;
    z-index: 999;
`;

export const OrderTable = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
`;

export const OrderTableCustom = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
    tr.ant-table-expanded-row > td,
    tr.ant-table-expanded-row:hover > td {
        background: #cccccc !important;
    }

    /* Mobil responsive ayarlar */
    @media (max-width: 768px) {
        .ant-table {
            font-size: 12px;
        }

        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            padding: 8px 4px;
        }

        .ant-table-scroll {
            overflow-x: auto;
        }
    }
`;

export const PickupTableCustom = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
    tr.ant-table-expanded-row > td,
    tr.ant-table-expanded-row:hover > td {
        background: #cccccc !important;
    }

    .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
        margin: unset;
    }

    /* Mobil responsive ayarlar */
    @media (max-width: 768px) {
        .ant-table {
            font-size: 12px;
        }

        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            padding: 8px 4px;
        }

        .ant-table-scroll {
            overflow-x: auto;
        }
    }
`;
export const ReturnTableCustom = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
    tr.ant-table-expanded-row > td,
    tr.ant-table-expanded-row:hover > td {
        background: #cccccc !important;
    }

    .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
        margin: unset;
    }

    /* Mobil responsive ayarlar */
    @media (max-width: 768px) {
        .ant-table {
            font-size: 12px;
        }

        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            padding: 8px 4px;
        }

        .ant-table-scroll {
            overflow-x: auto;
        }
    }
`;

export const MapLegend = styled.div`
    position: absolute;
    right: 4px;
    bottom: 4px;
    background: rgba(255, 255, 255, 0.92);
    padding: 6px 10px;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    font-size: 10px;
    min-width: 155px;
    max-width: 210px;

    .legend-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        &:last-child {
            margin-bottom: 0;
        }

        .legend-line {
            width: 16px;
            height: 3px;
            margin-right: 6px;
            border-radius: 2px;
        }

        .legend-text {
            font-weight: 500;
            color: #333;
            white-space: nowrap;
        }
    }
`;

export const CancelButton = styled(Button)`
    margin-left: 8px;
`;

export const QueueModalContainer = styled.div`
    width: 600px;
    background-color: white;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const PrepModalContainer = styled.div`
    width: 600px;
    background-color: white;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const MinusCircleFilledIcon = styled(MinusCircleFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const FileImageFilledIcon = styled(FileImageFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const SelectField = styled(Select)`
    width: 100%;
`;

export const PrepDetailContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
`;
